import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { defaultTo, isNil } from 'ramda'
import * as OrgSelectors from 'app/modules/org/selectors'
import _map from 'lodash/map'
import Accordion from 'components/shared/Accordion'
import { fetchDriftHelpStatus } from 'app/modules/org/actions'
import { renderLogo, renderLogoSVG } from '../helpers'
import { HELP_CENTER_HELPDOC_URL } from 'constants/HelpDocConstants'
import { Button } from '@driftt/tide-core-legacy'
import DriftHelp from '../services/DriftHelp'
import WordPress from '../services/WordPress'
import Zendesk from '../services/Zendesk'
import HelpScout from '../services/HelpScout'
import HelpDocs from '../services/HelpDocs'
import GDPRMessage from '../../GDPRMessage'
import ACCESS from 'utils/Access'
import styles from './style.styl'


const DRIFT_BOT_SKILLS_LINK = '/settings/routing'
const DRIFT_HELP_REPORTS = '/help/reports'

const defaultToEmptyObject = defaultTo({})

const logoSrc = {
  drifthelp: require("!svg-inline?removeTags=true!images/logos/drift-logo-2020.svg"),
  wordpress: require("!svg-inline?removeTags=true!images/logos/wordpress-text-logo.svg"),
  zendesk: require("!svg-inline?removeTags=true!images/logos/zendesk-full-logo.svg"),
  helpscout: require("images/logos/helpscout.svg"),
  helpdocs: require("images/logos/helpdocs-logo.svg")
}

// these keys should correspond with
// the integrationStates object
const getServives = wordpressType => {
  return {
    driftHelp: {
      title: renderLogoSVG(logoSrc.drifthelp),
      Service: DriftHelp
    },
    [wordpressType]: {
      title: renderLogoSVG(logoSrc.wordpress),
      Service: WordPress
    },
    zendesk: {
      title: renderLogoSVG(logoSrc.zendesk),
      Service: Zendesk
    },
    helpScout: {
      title: renderLogo(logoSrc.helpscout),
      Service: HelpScout
    },
    helpdocsio: {
      title: renderLogo(logoSrc.helpdocs),
      Service: HelpDocs
    }
  }
}



class HelpCenterPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDriftHelpEnabled: null,
    }
    this.isDriftHelpConnected()
  }

  isDriftHelpConnected = async () => {
    const response = await this.props.actions.fetchDriftHelpStatus()
    this.setState({
      isDriftHelpEnabled: response,
    })
  }

  renderServices = () => {
    const { integrationStates } = this.props
    const { isDriftHelpEnabled } = this.state

    const wordpressIntegrationType = ACCESS.hasGates('HAS_WORDPRESS_V2') ? 'wordpressV2' : 'wordpress'
    const Services = getServives(wordpressIntegrationType)

    return _map(Services, ({ Service, title }, serviceName) => {
      let isConnected

      if (serviceName === "driftHelp" && isNil(integrationStates[serviceName])) {
        isConnected = isDriftHelpEnabled
      } else {
        isConnected = integrationStates[serviceName]
      }

      return (
        <Accordion className={serviceName} key={serviceName} title={title} isConnected={isConnected}>
          <Service isConnected={isConnected} />
        </Accordion>
      )
    })
  }

  render() {
    return (
      <div>
        <Accordion
          key="help-center-intro"
          title="Connect Your Knowledge Base to Driftbot"
          locked
          className="help-center-settings-header"
        >
          <p>
            When you connect your knowledge base to Drift, Driftbot will surface
            help article links in the conversation.
          </p>
            <p>
              With the <a href={DRIFT_HELP_REPORTS}>Drift Help report</a> we’ll share personalized insights to help you improve your automated support workflow.
            </p>
          <p>
            When someone asks Driftbot a question or responds to your welcome message, Driftbot will surface the best help article links to the questions you have already answered and enable your customers to submit a ticket from the conversation so you can save your brain power for the bigger questions!
          </p>
          <div className="help-center-buttons">
            <Button className="second" type="tertiary" href={HELP_CENTER_HELPDOC_URL} target="_blank">
              Learn More
            </Button>
          </div>
        </Accordion>
        {this.renderServices()}
        <div className="gdpr-message-wrapper">
          <GDPRMessage />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  orgId: defaultToEmptyObject(OrgSelectors.orgId(state)),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchDriftHelpStatus }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(HelpCenterPage)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/HelpCenter.js